import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { DEFAULT_REGION, buildRegionPath } from '../regions';

interface UnsupportedRegionProps {
  requestedRegion?: string | null;
}

const UnsupportedRegion: React.FC<UnsupportedRegionProps> = ({ requestedRegion }) => {
  return (
    <Layout>
      <div className="mx-auto max-w-2xl space-y-6 text-center">
        <h1 className="text-3xl font-semibold text-gray-900">We’re not in that state yet</h1>
        <p className="text-base text-gray-600">
          {requestedRegion
            ? `OppFoundry doesn’t support “${requestedRegion.toUpperCase()}” just yet.`
            : 'OppFoundry doesn’t recognise that state yet.'}
        </p>
        <p className="text-sm text-gray-500">
          We’re focused on Massachusetts right now, and we’ll expand to more states soon. Use the navigation above to
          explore active regions or head back to the Massachusetts hub.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to={buildRegionPath(DEFAULT_REGION)}
            className="inline-flex items-center rounded-full bg-blue-600 px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-500"
          >
            Massachusetts Home
          </Link>
          <Link
            to={buildRegionPath(DEFAULT_REGION, 'contracts')}
            className="inline-flex items-center rounded-full border border-blue-200 px-5 py-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-50"
          >
            Browse Massachusetts Contracts
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default UnsupportedRegion;
